import { createFileRoute, redirect } from '@tanstack/react-router'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'

// Redirector: /documents -> /org/$orgId/documents
export const Route = createFileRoute('/_authenticated/_dashboard/documents/')({
  component: () => null,
  beforeLoad: async () => {
    const store = useSelectedTenantStore.getState()
    if (store.selectedTenantId) {
      throw redirect({
        to: '/org/$orgId/documents',
        params: { orgId: store.selectedTenantId },
        search: (prev) => prev,
      })
    }
    throw redirect({ to: '/select-tenant' })
  },
})
